/* eslint-disable react/no-unescaped-entities */
import React from 'react';
import { Container, Row } from 'react-bootstrap';

function Career() {
  return (
    <section>
      <Container fluid className="home-section">
        <Container className="home-content">
          <Row>
            <h1 className="purple">
              ディーピーティー株式会社 (2023/6 ~ current)
            </h1>

            <h2>
              <i>
                <b>My Role : </b> Responsible for developing, and maintaining
                web applications using React for frontend and Laravel for
                backend. Collaborate with cross-functional teams to implement
                scalable solutions, optimize performance, and ensure seamless
                user experiences. Work on API integrations, database management,
                and modern development practices to deliver high-quality
                software solutions.
              </i>
            </h2>
            <h2>
              <i>
                <b>Location : </b> Nagoya, Japan
              </i>
            </h2>
            <h2>
              <i>
                <b>Department : </b> Software design and Development
              </i>
            </h2>
            <h2>
              <i>
                <b>My Position : </b> Senior Software Engineer (E2)
              </i>
            </h2>
            <h2>
              <i>
                <b>Programming Languages : </b> Javascript, PHP
              </i>
            </h2>
            <h2>
              <i>
                <b>Frameworks : </b> Next.js(React.js Framework), Laravel(PHP
                Framework)
              </i>
            </h2>
            <h2>
              <i>
                <b>Database : </b> MySQL
              </i>
            </h2>
            <h2>
              <i>
                <b>Operating System : </b> Windows , Linux
              </i>
            </h2>
            <h2>
              <i>
                <b>Tools : </b> Git , Docker, VSCode, Node.js, NPM, YARN,
                TailwindCSS, Figma, App Diagram, Teraterm, WinSCP
              </i>
            </h2>
          </Row>
          <br />
          <br />
          <Row>
            <h1 className="purple">株式会社オファサポート (2020/1 ~ 2023/5)</h1>

            <h2>
              <i>
                <b>My Role : </b> Responsible for developing, and maintaining
                web applications using jQuery for frontend and Laravel or
                Wordpress for backend. Optimize performance, and ensure seamless
                user experiences. Work on database management, and modern
                development practices to deliver high-quality software
                solutions.
              </i>
            </h2>
            <h2>
              <i>
                <b>Location : </b> Miyazaki, Japan
              </i>
            </h2>
            <h2>
              <i>
                <b>Department : </b> IT
              </i>
            </h2>
            <h2>
              <i>
                <b>My Position : </b> Software Engineer
              </i>
            </h2>
            <h2>
              <i>
                <b>Programming Languages : </b> Javascript, PHP
              </i>
            </h2>
            <h2>
              <i>
                <b>Frameworks : </b> jQuery(Javascript Library), Laravel(PHP
                Framework), Wordpress
              </i>
            </h2>
            <h2>
              <i>
                <b>Database : </b> MySQL
              </i>
            </h2>
            <h2>
              <i>
                <b>Operating System : </b> Windows , Linux
              </i>
            </h2>
            <h2>
              <i>
                <b>Tools : </b> Git, VSCode Bootstrap, Teraterm, WinSCP
              </i>
            </h2>
          </Row>
          <br />
          <br />
          <Row>
            <h1 className="purple">Hypertag Solutions (2017/2 ~ 2019/1)</h1>

            <h2>
              <i>
                <b>My Role : </b> Responsible for developing,testing, and
                maintaining web applications using jQuery for frontend and
                Laravel for backend.
              </i>
            </h2>
            <h2>
              <i>
                <b>Location : </b> Dhaka, Bangladesh
              </i>
            </h2>
            <h2>
              <i>
                <b>Department : </b> Software Development
              </i>
            </h2>
            <h2>
              <i>
                <b>My Position : </b> Software Engineer
              </i>
            </h2>
            <h2>
              <i>
                <b>Programming Languages : </b> Javascript, PHP
              </i>
            </h2>
            <h2>
              <i>
                <b>Frameworks : </b> jQuery, Laravel(PHP Framework)
              </i>
            </h2>
            <h2>
              <i>
                <b>Database : </b> MySQL
              </i>
            </h2>
            <h2>
              <i>
                <b>Operating System : </b> Windows , Linux
              </i>
            </h2>
            <h2>
              <i>
                <b>Tools : </b> Git, VSCode, Bootstrap
              </i>
            </h2>
          </Row>
        </Container>
      </Container>
    </section>
  );
}

export default Career;
